export default [
  {
    width: 12,
    header: {
      type: 'text',
      caption: 'Date',
      sort: 'dateCreated',
    },
    cell: {
      type: 'slot',
      name: 'dateCreated',
    },
  },
  {
    width: 13,
    header: {
      type: 'text',
      caption: 'User',
    },
    cell: {
      type: 'slot',
      name: 'user',
    },
  },
  {
    width: 7,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'text',
      value: (e) => e.currencyTitle,
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'type',
    },
  },
  // {
  //   width: 10,
  //   header: {
  //     type: 'text',
  //     caption: 'Status',
  //   },
  //   cell: {
  //     type: 'slot',
  //     name: 'status',
  //   },
  // },
  // {
  //   width: 10,
  //   header: {
  //     type: 'text',
  //     caption: 'Volume',
  //     sort: 'amount',
  //   },
  //   cell: {
  //     type: 'slot',
  //     name: 'volume',
  //   },
  // },
  {
    width: 8,
    header: {
      type: 'text',
      caption: 'Perc',
    },
    cell: {
      type: 'slot',
      name: 'perc',
    },
  },
  {
    width: 50,
    header: {
      type: 'text',
      caption: 'Comment',
    },
    cell: {
      type: 'slot',
      name: 'comment',
    },
  },
];
